import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-revocazione-view',
  templateUrl: './form-revocazione-view.component.html',
  styleUrls: ['./form-revocazione-view.component.css']
})
export class FormRevocazioneViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
